import React, {useCallback, useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import './styles.css';
const Segmented = ({ checked, options, onChange, children }) => {
  const [selectedOption, setSelectedOption] = useState(null);

  const handleChange = useCallback(option => {
    setSelectedOption(option);
    onChange(option.value);
  }, [onChange]);

  useEffect(() => {
    if (checked) {
      const selected = options.find(option => option.value === checked);
      setSelectedOption(selected);
    } else {
      setSelectedOption(null);
    }
  }, [checked, options]);

  return (
    <div className="segmented">
      <div className={'segmented__options'}>
        {options.map(option => (
          <button
            key={option.value}
            type={'button'}
            className={`segmented__option ${selectedOption && selectedOption.value === option.value ? 'segmented__option--selected' : ''}`}
            onClick={() => {
              handleChange(option);
            }}
          >
            <span className="segmented__label">
              {option.label}
            </span>
          </button>
        ))}
      </div>
      {selectedOption && !!selectedOption.helpText && (
        <div className="segmented__help-text">
          {selectedOption.helpText}
        </div>
      )}
      {children}
    </div>
  );
};
Segmented.propTypes = {
  options: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  checked: PropTypes.string,
};
export default Segmented;
